import React from 'react'
import { PolicyLogoContainer } from './styles'
import { Certificate } from '../../../components/SVG/document-icons/certificate'
import { TempcoverContract } from '../../../components/SVG/document-icons/tempcoverContract'
import { PolicyWording } from '../../../components/SVG/document-icons/policyWording'
import { IPID } from '../../../components/SVG/document-icons/ipid'
import { PolicySchedule } from '../../../components/SVG/document-icons/policySchedule'
import { StatementOfFact } from '../../../components/SVG/document-icons/statementOfFact'
import { PolicyEndoresement } from 'components/SVG/document-icons/policyEndorsement'
import { GenericDoc } from 'components/SVG/document-icons/genericDoc'

interface Props {
  name?: string
  document?: Record<string, any>
}

export const PolicyDocumentLogo: React.FC<Props> = ({ name, document }) => {
  if (name) {
    switch (name) {
      case 'TempcoverContract':
        return (
          <PolicyLogoContainer>
            <TempcoverContract />
          </PolicyLogoContainer>
        )
      case 'FullDeclaration':
        return (
          <PolicyLogoContainer>
            <Certificate />
          </PolicyLogoContainer>
        )
      case 'PolicyWording':
        return (
          <PolicyLogoContainer>
            <PolicyWording />
          </PolicyLogoContainer>
        )
      case 'ProductInformation':
        return (
          <PolicyLogoContainer>
            <IPID />
          </PolicyLogoContainer>
        )
      default:
        return (
          <PolicyLogoContainer>
            <GenericDoc />
          </PolicyLogoContainer>
        )
    }
  }

  if (document) {
    switch (document.DocumentName) {
      case 'Certificate of Motor Insurance':
        return (
          <PolicyLogoContainer>
            <Certificate />
          </PolicyLogoContainer>
        )
      case 'Tempcover Contract':
        return (
          <PolicyLogoContainer>
            <TempcoverContract />
          </PolicyLogoContainer>
        )
      case 'Statement of Fact':
        return (
          <PolicyLogoContainer>
            <StatementOfFact />
          </PolicyLogoContainer>
        )
      case 'New Policy Schedule':
        return (
          <PolicyLogoContainer>
            <PolicySchedule />
          </PolicyLogoContainer>
        )
      case 'Excess Reduction Policy Schedule':
        return (
          <PolicyLogoContainer>
            <PolicySchedule />
          </PolicyLogoContainer>
        )
      case 'Insurance Product Information':
        return (
          <PolicyLogoContainer>
            <IPID />
          </PolicyLogoContainer>
        )
      case 'Excess Reduction Product Information':
        return (
          <PolicyLogoContainer>
            <IPID />
          </PolicyLogoContainer>
        )

      case 'Policy Wording':
        return (
          <PolicyLogoContainer>
            <PolicyWording />
          </PolicyLogoContainer>
        )
      case 'Excess Reduction Policy Wording':
        return (
          <PolicyLogoContainer>
            <PolicyWording />
          </PolicyLogoContainer>
        )
      case 'Policy Endorsement':
        return (
          <PolicyLogoContainer>
            <PolicyEndoresement />
          </PolicyLogoContainer>
        )
      default:
        return (
          <PolicyLogoContainer>
            <GenericDoc />
          </PolicyLogoContainer>
        )
    }
  }
  return (
    <PolicyLogoContainer>
      <GenericDoc />
    </PolicyLogoContainer>
  )
}
